import BaseBehavior from '../../../framework/base/base';
import { initBehaviors } from '../../../shared/utilities/behaviors';

export default class CookieBotList extends BaseBehavior {
	constructor(element) {
		super(element);
		this.dialogInitialized = false;
		window.addEventListener('CookiebotOnDialogInit', () => {
			if (this.dialogInitialized === false) {
				const cookieCategory = element.dataset.cookieCategories.split(',');
				this.populateCookieData(cookieCategory);
				this.dialogInitialized = true;
			}
		});
		if (!window.Cookiebot.dialog) {
			window.Cookiebot.process();
		}
	}

	populateCookieData(cookieCategory) {
		const data = cookieCategory.map(name => {
			return [
				window.Cookiebot.dialog[`cookieHeaderType${name}`].replace('({0})', '').trim(),
				window.Cookiebot.dialog[`cookieIntroType${name}`],
				window.Cookiebot.dialog[`cookieTable${name}`]
			];
		});

		const tableFragment = document.createDocumentFragment();

		data.forEach(x => {
			if (x[2]) {
				// only insert if data is available
				const wrapper = document.createElement('div');
				wrapper.innerHTML = this.createSection(x[0], x[1], x[2], x[0]);
				tableFragment.appendChild(wrapper);
			}
		});

		this.element.querySelector('.v2-responsive-table').appendChild(tableFragment);
		const fixedTableContainers = this.element.querySelectorAll('.v2-responsive-table__content');
		fixedTableContainers.forEach(container => {
			initBehaviors({ context: container });
		});
	}

	createSection(name, intro, data, categoryName) {
		const reducer = (accumulator, currentValue) => accumulator + currentValue;
		const rows = data?.map(colArray => this.createRow(colArray)).reduce(reducer, ``);
		return `
				<section class="v2-accordion v2-accordion--no-border v2-mab10">
				<input type="checkbox" class="v2-hidden" id="${categoryName}" checked=true />
				<label for="${categoryName}" class="v2-accordion__toggle v2-accordion__header v2-bg--lighter-gray">
					<div class="text">
						<h4 class="v2-mat15">${name}</h4>
						<h5>${intro}</h5>
					</div>
					<span>												
						<svg data-cy="icon" class="v2-icon v2-accordion__header-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
							<path d="M1.05713 4.12009L6.67999 9.74294C6.72103 9.78665 6.7706 9.82157 6.82564 9.84534C6.88067 9.86921 6.94001 9.88146 6.99999 9.88146C7.05996 9.88146 7.1193 9.86921 7.17433 9.84534C7.22937 9.82157 7.27894 9.78665 7.31999 9.74294L12.9428 4.12009" stroke="#141A27" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</span>
				</label>
				
				<div class="v2-responsive-table__content v2-pav10 v2-accordion__body" 
					data-element="cookiebot-table" data-behavior="fixed-table">
					<div class="v2-table-container">
						<table class="v2-table">
							<thead class="v2-bg--white">
							<tr>
								<th class="v2-table__fixed-col">${window.Cookiebot.dialog.cookieTableHeaderName}</th>
								<th>${window.Cookiebot.dialog.cookieTableHeaderProvider}</th>
								<th>${window.Cookiebot.dialog.cookieTableHeaderPurpose}</th>
								<th>${window.Cookiebot.dialog.cookieTableHeaderExpiry}</th>
								<th>${window.Cookiebot.dialog.cookieTableHeaderType}</th>
							</tr>
							</thead>
							<tbody>
								${rows}
							</tbody>
						</table>
					</div>
				</div>
				</section>`;
	}

	createRow(colArray) {
		const reducer = (accumulator, currentValue) => accumulator + currentValue;
		const cols = colArray
			.filter((data, index) => index < 5)
			.map((colData, index) => {
				const fixedColClass = index === 0 ? 'v2-table__fixed-col' : '';
				return `<td class=${fixedColClass} >${colData}</td>`;
			})
			.reduce(reducer);

		return `<tr>
			${cols}
		</tr>
		`;
	}
}
